// Device identity + unlocked-map memory for self-guided access (12h window)
const DEVICE_KEY = "wc_device_id";
const UNLOCKED_KEY = "wc_unlocked";

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `dev-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

export function getUnlocked() {
  try {
    const list = JSON.parse(localStorage.getItem(UNLOCKED_KEY) || "[]");
    const now = Date.now();
    const valid = list.filter((e) => new Date(e.expires_at).getTime() > now);
    if (valid.length !== list.length) localStorage.setItem(UNLOCKED_KEY, JSON.stringify(valid));
    return valid;
  } catch {
    return [];
  }
}

export function saveUnlocked(entry) {
  const list = getUnlocked().filter((e) => e.route_id !== entry.route_id);
  list.push(entry);
  localStorage.setItem(UNLOCKED_KEY, JSON.stringify(list));
}

export function removeUnlocked(routeId) {
  const list = getUnlocked().filter((e) => e.route_id !== routeId);
  localStorage.setItem(UNLOCKED_KEY, JSON.stringify(list));
}

export function remainingText(expiresAt) {
  const ms = new Date(expiresAt).getTime() - Date.now();
  if (ms <= 0) return "Expired";
  const h = Math.floor(ms / 3600000);
  const m = Math.floor((ms % 3600000) / 60000);
  if (h > 0) return `${h}h ${m}m left`;
  return `${m}m left`;
}

function hav(a, b) {
  const R = 6371;
  const dLat = (b[0] - a[0]) * Math.PI / 180;
  const dLon = (b[1] - a[1]) * Math.PI / 180;
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(a[0] * Math.PI / 180) * Math.cos(b[0] * Math.PI / 180) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(x));
}

export function nearestPathIndex(path, lat, lng) {
  let best = 0, bd = Infinity;
  for (let i = 0; i < path.length; i++) {
    const d = (path[i][0] - lat) ** 2 + (path[i][1] - lng) ** 2;
    if (d < bd) { bd = d; best = i; }
  }
  return best;
}

// Returns the slice of the route line and its length (km) between two stops.
export function routeLeg(path, from, to) {
  if (!from || !to) return { slice: [], km: 0 };
  if (!path || path.length < 2) return { slice: [], km: hav([from.lat, from.lng], [to.lat, to.lng]) };
  let i = nearestPathIndex(path, from.lat, from.lng);
  let j = nearestPathIndex(path, to.lat, to.lng);
  if (i > j) [i, j] = [j, i];
  const slice = path.slice(i, j + 1);
  let km = 0;
  for (let k = 0; k < slice.length - 1; k++) km += hav(slice[k], slice[k + 1]);
  return { slice, km };
}

export function kmText(km) {
  if (!km) return "";
  return km >= 1 ? `${km.toFixed(1)}km away` : `${Math.round(km * 1000)}m away`;
}
